import {Dispatch} from 'react'
import {COMPROBANTE_RETENCION_TYPES} from '../../constants/comprobanteRetencion.types'
import {State} from '../../reducers'
import {comprobanteRetencionModalsClose} from './comprobanteRetencionProductos.actions'
import {comprobanteRetencionFormClienteValidacionesGenerarFactura} from './comprobanteRetencionCliente.actions'
import {generalOpenModalError, generalOpenModalInfo, generalOpenModalMessage, generalShowLoader, getFechaHora} from '../general.actions'
import {KEYS} from '../../constants/keysStorage'
import * as http from '../../api/http'
import {ENDPOINTS} from '../../api/config'
import {setDatosGeneralesEmisor} from '../catalogos.actions'
import {getFechaCA, getFechaFormato1, getHoraNow} from '../../utils/stringDate'
import {getQR} from '../operaciones/operaciones.actions'
import {comprobanteRetencionFormSucursalValidacion} from './comprobanteRetencionSucursal.actions'
import {CREClienteF, ComprobanteRetencionAction} from '../../interfaces/comprobante-retencion.interface'
import {setResultAnulaciones} from '../historial/historial.actions'
import { guardarClienteReceptor } from '../operaciones/clienteReceptor.actions'
import { roundToTwo } from '../../utils/numbers.utils'
import { docsDatosReceptorReset, docsDatosReceptorSiguiente } from '../documentos/documentos.actions'
import { unirChipsJoin, unirChipsReturnFirst } from '../../utils/strings.utils'

export const comprobanteRetencionClearAll = (flag: boolean = false) => ({ type: COMPROBANTE_RETENCION_TYPES.CRE_TYPE_CLEAR_ALL, payload: flag, })

export const comprobanteRetencionSetDatosEmisor = (emisor: any) => ({ type: COMPROBANTE_RETENCION_TYPES.CRE_TYPE_SET_DATOS_EMISOR, payload: emisor, })

export const comprobanteRetencionSetDatosFactura = (factura: any) => ({ type: COMPROBANTE_RETENCION_TYPES.CRE_TYPE_SET_DATOS_FACTURA, payload: factura, })

export const comprobanteRetencionSetFacturaEmitida = (flag: any) => ({ type: COMPROBANTE_RETENCION_TYPES.CRE_TYPE_FACTURA_EMITIDA, payload: flag, })

export const comprobanteRetencionSetActivarOpciones = () => ({ type: COMPROBANTE_RETENCION_TYPES.CRE_TYPE_OPCIONES_ACTIVA, payload: true, })

export const comprobanteRetencionSetCatalogoSucursal = (sucursales: any) => ({ type: COMPROBANTE_RETENCION_TYPES.CRE_TYPE_SET_CATALOGO_SUCURSAL, payload: sucursales, })

export const comprobanteRetencionSetCatalogoSerie = (series: any) => ({ type: COMPROBANTE_RETENCION_TYPES.CRE_TYPE_SET_CATALOGO_SERIE, payload: series, })

export const comprobanteRetencionSetUUID = (uuid: any) => ({ type: COMPROBANTE_RETENCION_TYPES.CRE_TYPE_SET_UUID, payload: uuid, })

export const comprobanteRetencionAnulado = (flag: boolean) => ({ type: COMPROBANTE_RETENCION_TYPES.CRE_TYPE_ANULADO, payload: flag, })

// ******************************************************************************************
export const comprobanteRetencionSetModalEmitirFactura = (flag: boolean) => ({ type: COMPROBANTE_RETENCION_TYPES.CRE_TYPE_MODALFACTURACION_OPEN, payload: {activeEmitirFactura: flag}, })

export const comprobanteRetencionSetModalFacturaEmitida = (flag: boolean) => ({ type: COMPROBANTE_RETENCION_TYPES.CRE_TYPE_MODALFACTURACION_OPEN, payload: {activeFacturaEmitida: flag}, })

export const comprobanteRetencionSetModalImpresion = (flag: boolean) => ({ type: COMPROBANTE_RETENCION_TYPES.CRE_TYPE_MODALIMPRESION_OPEN, payload: flag, })

export const comprobanteRetencionSetModalEmail = (flag: boolean) => ({ type: COMPROBANTE_RETENCION_TYPES.CRE_TYPE_MODALEMAIL_OPEN, payload: flag, })

export const comprobanteRetencionSetModalAnular = (flag: boolean) => ({ type: COMPROBANTE_RETENCION_TYPES.CRE_TYPE_MODALANULAR_OPEN, payload: flag, })

// ******************************************************************************************
// ? FUNCIONES O PROCEDIMIENTOS SIN PETICIONES RES
// ******************************************************************************************
export const comprobanteRetencionClicGenerarFactura = () => async (dispatch: Dispatch<ComprobanteRetencionAction>, getState: () => State) => {
    if (comprobanteRetencionFormClienteValidacionesGenerarFactura(dispatch, getState)) {
      window.scroll(0, 0)
      const form = getState().comprobanteRetencion.errorsFormCliente
      const hasErrors = Object.values(form).some(error => error);
      if (hasErrors) dispatch(generalOpenModalInfo('Datos incorrectos en el formulario Datos del Cliente'))       
      return false
    }
    if (comprobanteRetencionFormSucursalValidacion(dispatch, getState)) {
      window.scroll(0, 0)
      dispatch(generalOpenModalInfo('Datos incompletos en el formulario sucursal y serie'))
      return false
    }
    const array = getState().comprobanteRetencion.documentosAsociados
    if (array.length === 0) {
      dispatch(generalOpenModalInfo('Debe asociar al menos un documento para poder generar el comprobante'))
      return false
    }
    if(docsDatosReceptorSiguiente(dispatch, getState)) return false
    return true
  }

// ******************************************************************************************
// ? PETICIONES REST
// ******************************************************************************************
export const comprobanteRetencionGetDatosEmisor = () => async (dispatch: Dispatch<ComprobanteRetencionAction>, getState: () => State) => {
  const datos = getState().catalogos.datosEmisor;
  if (datos !== null && Object.keys(datos).length > 0) {
    dispatch(comprobanteRetencionSetDatosEmisor(getState().catalogos.datosEmisor))
    return
  }

  http.get(ENDPOINTS.FACTURACION_GET_EMPRESA_EMISOR, {}, KEYS.TOKEN)
    .then(async (res: any) => {
      if (res?.message) return dispatch(generalOpenModalError(res.message))
      const response = {...res.body, departamento: { idDepartamento: res?.body?.departamento, valor: res?.body?.departamentonombre, }, municipio: { idMmunicipio: res?.body?.municipio, valor: res?.body?.municipionombre, }, }
      dispatch(comprobanteRetencionSetDatosEmisor(response))
      dispatch(setDatosGeneralesEmisor(response))
    })
    .catch((err) => {
      let message = 'No se logró obtener los datos del Emisor'
      dispatch(generalOpenModalError(err?.response?.data?.message ?? message, err?.response?.data?.status))
    })
}

export const comprobanteRetencionPostSucursales = () => async (dispatch: Dispatch<ComprobanteRetencionAction>, getState: () => State) => {
  const {datos} = getState().userLogin;
  let message = 'No se logró obtener el catalogo de sucursales'
  await http
      .post(ENDPOINTS.FACTURACION_POST_SUCURSALES, {
        idsucursal: `${datos.sucursal_seleccionada}`,
        tipodocumento: '07'
      }, {}, KEYS.TOKEN)
      .then(async (res: any) => {
        if (res.body && !res.message) {
          const sucursal = res.body;
          const hayDocs = sucursal[0]?.Documento?.length;
          if (!hayDocs) {
            dispatch(comprobanteRetencionSetCatalogoSucursal([]))
          } else {
            dispatch(comprobanteRetencionSetCatalogoSucursal(res.body))
          }
        } else {
          dispatch(generalOpenModalError(res.message || message))
        }
      })
      .catch((err) => {
        if(err?.response?.data?.errorCode === 1) { dispatch(comprobanteRetencionSetCatalogoSucursal([])); return; }
        dispatch(generalOpenModalError(err?.response?.data?.message ?? message, err?.response?.data?.status))
      })
}

export const comprobanteRetencionGetUUID = (tipoDoc: string | null = null) => async (dispatch: Dispatch<ComprobanteRetencionAction>) => {
  let message = 'No se logró obtener el UUID del documento'
  const params = {TipoDOc: tipoDoc || '07'}
  await http.get(ENDPOINTS.FACTURACION_GET_UUID, params, KEYS.TOKEN)
    .then(async (res: any) => {
      if (res.body && !res.message) {
        dispatch(comprobanteRetencionSetUUID(res.body))
        return
      }
      dispatch(generalOpenModalError(res.message || message))
    })
    .catch((err) => {
      dispatch(generalOpenModalError(err?.response?.data?.message || message, err?.response?.data?.status))
    })
}

export const comprobanteRetencionClicEmitirFactura = () => async (dispatch: Dispatch<ComprobanteRetencionAction>, getState: () => State) => {
  if (comprobanteRetencionFormClienteValidacionesGenerarFactura(dispatch, getState)) {
    dispatch(generalOpenModalInfo('Datos incorrectos en el formulario Datos del Cliente'))
    return false
  }
  if (comprobanteRetencionFormSucursalValidacion(dispatch, getState)) {
    window.scroll(0, 0)
    dispatch(generalOpenModalInfo('Datos incompletos en el formulario sucursal y serie'))
    return false
  }
  const array = getState().comprobanteRetencion.documentosAsociados
  if (array.length === 0) {
    dispatch(generalOpenModalInfo('Debe asociar al menos un documento para poder generar el comprobante'))
    return false
  }
  if(docsDatosReceptorSiguiente(dispatch, getState)) return false
  dispatch(comprobanteRetencionSetModalEmitirFactura(true))
}

export const comprobanteRetencionCloseModalEmitir = () => async (dispatch: Dispatch<ComprobanteRetencionAction>) => { dispatch(comprobanteRetencionSetModalEmitirFactura(false)) }
/**
 * comprobanteRetencionClicEmitirModal = emite la factura
 * @param history hook useHistory
 * @returns void
 */
export const comprobanteRetencionClicEmitirModal =
  (history: any) => async (dispatch: Dispatch<any>, getState: () => State) => {
    if (getState().general.loader) return
    dispatch(generalShowLoader(true))
    const {formCliente, formSucursal, documentosAsociados, calculosArrayProductos, datosUUID} = getState().comprobanteRetencion
    const {tipoDocumentosEmision} = getState().catalogos
    const horasActuales:any = await dispatch(getFechaHora());
    const user = localStorage.getItem(KEYS.ID_CLIENT)
    let doc = formCliente.numId?.trim() || ''
    if (formCliente.tipoDocumento === KEYS.DOCUMENTO_DUI_ID && doc.length > 1) doc = `${doc.substring(0,doc.length-1)}-${doc[doc.length-1]}`
    const cuerpoDocumento:Array<any> = [];
    const datosReceptor = getState().documentos.datosReceptor.form

    documentosAsociados.forEach((d:any) => {
      let prod = {
        TipoDte: d.TipoDte, // Tipo de documento tributario // pag 51
        tipoDoc: "1", // Tipo de generación del documento
        // numDocumento: d.DetallesDTE.receptor?.nit || d.DetallesDTE.receptor?.numDocumento, // numero de control del documento
        numDocumento: d.numDocumento, // numero de control del documento
        fechaEmision: d.fechaEmision, // fecha de generación del documento
        montoSujetoGrav: d.montoSujetoGrav, // valor neto que fue sujeto de retención por cada documento informado detallado en cada item, pag 58
        codigoRetencionMH: "22", // 22 Retención IVA 1%
        ivaRetenido:  d.ivaRetenido, // resultado monto sujeto grav * 1%
        descripcion: d?.descripcion || "",
        TipoDocName: tipoDocumentosEmision?.find((tipo) => tipo.codigodocumento === d?.TipoDte)?.nombre, // campo para comprobante
        fechaEmisionFormat: getFechaCA(d?.fechaEmision), // campo para comprobante
        numeroControl: d.numeroControl, // campo para comprobante numero de control
      }
      cuerpoDocumento.push(prod)
    })

    let body: any = {
      id_user: user,
      facturas: [{
          receptorManual: datosReceptor.nombre,
          docManual: datosReceptor.numId,
          esReceptorManual : datosReceptor.esReceptorManual,
          tipoDocManual : datosReceptor.nombreTipoDocumento,
          idsucursaldocumento: formSucursal?.datosSerie?.idsucursaldocumento,
          receptorEmailsEnvio: unirChipsJoin(formCliente.chipsEmail!, formCliente.email!),
          tipoDte: '07',
          cveDoc: `${formSucursal?.datosSerie?.serie}-${formSucursal?.datosSerie?.numeroactual}`,
          uuid: datosUUID?.CodigoGeneracion,
          fechaDoc: horasActuales ? (`${horasActuales.FechaDDMM} ${horasActuales.Hora}`) : `${getFechaFormato1()} ${getHoraNow()}`,
          totalSujetoRetencion: calculosArrayProductos.totalMontoSujeto,
          totalIVAretenido: calculosArrayProductos.totalIvaRetenido,
          cuerpoDocumento: cuerpoDocumento,
          receptor: {
            tipoDocumento: formCliente.tipoDocumento,
            numDocumentoReceptor: doc,
            nrc: formCliente.nrc,
            nombre: formCliente.nombre?.trim(),
            direccion: formCliente.direccion?.trim(),
            email: unirChipsReturnFirst(formCliente.chipsEmail!, formCliente.email!),
            telefono: formCliente.telefono?.trim(),
            codActividad: formCliente.actividad?.trim(),
            descAtvividad: formCliente.descripcion?.trim(),
            departamento: formCliente.departamento,
            municipio: formCliente.municipio,
          },
        },
      ],
      tokenGateway: localStorage.getItem(KEYS.TOKEN) ?? '',
      tokenHacienda: localStorage.getItem(KEYS.HACIENDA) ?? '',
    }
    if(formCliente.tipoDocumento && formCliente.numId) guardarClienteReceptor(formCliente, dispatch)
    let message = 'Se produjo un error al momento de emitir el comprobante, inténtelo nuevamente.'

    await http.post(ENDPOINTS.FACTURACION_POST_RECEPCION_DTE, body, {}, KEYS.TOKEN)
      .then(async (res: any) => {
        if(res?.body?.NuevoToken){localStorage.setItem(KEYS.HACIENDA, res?.body?.TokenHacienda)}
        
        if (res?.body && !res.message) {
          if (res.body?.estado === 'PROCESADO') {
            window.scroll(0, 0)
            await dispatch(comprobanteRetencionSetDatosFactura(res.body))
            const {qr, message: ms} = await getQR(res?.body.JsonFactura)
            if (ms) dispatch(generalOpenModalError(ms))
            dispatch(comprobanteRetencionSetDatosFactura({qr}))
            await dispatch(comprobanteRetencionSetFacturaEmitida(true))
            await dispatch(comprobanteRetencionSetModalFacturaEmitida(true))
            await dispatch(comprobanteRetencionSetModalEmitirFactura(false))
            return
          }
          res.message = mostrarObservacionesError(res?.body?.observaciones, message, history, formCliente, dispatch)
        }
        dispatch(generalOpenModalError(res.message || message))
      })
      .catch((err: any) => {
        err.response.data.message = mostrarObservacionesError(err?.response?.data?.body?.observaciones, err?.response?.data?.body?.descripcionMsg, history, formCliente, dispatch)
        dispatch(generalOpenModalError(err?.response?.data?.message ? err?.response?.data?.message : message, err?.response?.data?.status))
      })
      .finally(() => dispatch(generalShowLoader(false)))
  }

const mostrarObservacionesError = (arrayObservaciones: any, message: string, history: any, formCliente: CREClienteF,dispatch: Dispatch<ComprobanteRetencionAction>): string => {
  if (Array.isArray(arrayObservaciones)) {
    const errorMessage = construirErrorMessage(arrayObservaciones, formCliente);
    if (errorMessage) {
      message = errorMessage;
      if (contieneCampoReceptor(arrayObservaciones)) {
        dispatch(comprobanteRetencionSetModalEmitirFactura(false))
        history.push('/emitir-factura/formulario');
      }
    }
  }
  return message;
};
  
const construirErrorMessage = (observaciones: string[], formCliente: CREClienteF): string => {
  let errorMessage = '';
  observaciones.forEach((el: string) => {
    if (el.trim().includes('Campo #/receptor/')) {
      el = el.replaceAll('Campo #/receptor/', 'Formulario con datos del cliente el campo: ');
      errorMessage += `<li>${el} o está vacío.</li>`;
    } else errorMessage += `<li>${el}.</li>`;
  });
  if (errorMessage)  errorMessage = `No se pudo generar la factura, Hacienda solicita llenar los siguientes campos:<br><br><ol>${errorMessage}</ol>`;
  return errorMessage;
};

const contieneCampoReceptor = (observaciones: string[]): boolean => {
  const cadena = 'Campo #/receptor';
  return observaciones.some((el: string) => el.trim().includes(cadena));
};

export const comprobanteRetencionCloseModalFacturaEmitida = () => async (dispatch: Dispatch<ComprobanteRetencionAction>) => { dispatch(comprobanteRetencionModalsClose()) }

export const comprobanteRetencionVerDetalleDocumentoEmitido = () => async (dispatch: Dispatch<ComprobanteRetencionAction>) => {
  dispatch(comprobanteRetencionSetActivarOpciones())
  dispatch(comprobanteRetencionModalsClose())
}

export const comprobanteRetencionCloseModalDocumentoEmitida = () => async (dispatch: Dispatch<ComprobanteRetencionAction>) => {
  dispatch(comprobanteRetencionClearAll())
  dispatch(docsDatosReceptorReset())
  dispatch(comprobanteRetencionModalsClose())
}

export const comprobanteRetencionOpenCloseModalImprimir = (flag: boolean = false) => async (dispatch: Dispatch<ComprobanteRetencionAction>) => {
  await dispatch(comprobanteRetencionSetModalImpresion(flag))
  await dispatch(comprobanteRetencionSetModalFacturaEmitida(!flag))
}

export const comprobanteRetencionOpenCloseModalEmail = (flag: boolean = false) => async (dispatch: Dispatch<ComprobanteRetencionAction>) => {
  await dispatch(comprobanteRetencionSetModalEmail(flag))
  await dispatch(comprobanteRetencionSetModalFacturaEmitida(!flag))
}

export const comprobanteRetencionOpenMasOpciones = () => async (dispatch: Dispatch<ComprobanteRetencionAction>) => {
  await dispatch(comprobanteRetencionSetActivarOpciones())
  await dispatch(comprobanteRetencionSetModalFacturaEmitida(true))
}

export const comprobanteRetencionOpenCloseModalAnular = (flag: boolean = false) => async (dispatch: Dispatch<ComprobanteRetencionAction>) => {
  dispatch(comprobanteRetencionSetModalAnular(flag))
  dispatch(comprobanteRetencionSetModalFacturaEmitida(false))
}

export const comprobanteRetencionVerificarAnulacion = (funcionRedirigir: () => void) => async (dispatch: Dispatch<ComprobanteRetencionAction>, getState: () => State) => {
  const {resultAnulaciones} = getState().historial
  const anulado = getState().comprobanteRetencion.anulado
  // Anulacion unitaria
  if (!anulado) {
    dispatch(comprobanteRetencionAnulado(resultAnulaciones[0].result))
    if (resultAnulaciones[0].result) {
      dispatch(generalOpenModalMessage("Documento anulado", "El documento ha sido anulado exitosamente."))
      funcionRedirigir()
      dispatch(setResultAnulaciones([]))
      return
    }
    else dispatch(generalOpenModalError(resultAnulaciones[0].msg))
  }
  dispatch(setResultAnulaciones([]))
  await dispatch(comprobanteRetencionSetModalAnular(false))
  await dispatch(comprobanteRetencionSetModalFacturaEmitida(true))
}